export const defaultsEnum = {
  labels: {
    table: 'N/D',
  },
};
